import { useMutation } from '@apollo/client';
import { setNotificationDisabled } from '@innovyze/stylovyze/lib/actions';
import { error } from '@innovyze/stylovyze/lib/actions/notifications.actions';
import * as FieldSwitchStyles from '@innovyze/stylovyze/lib/components/FieldSwitch/FieldSwitch.styles';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts';
import { useSelectNotificationHub } from '@innovyze/stylovyze/lib/selectors';
import { rem } from '@innovyze/stylovyze/lib/utils/styles';
import { FormControlLabel } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { TOGGLE_NOTIFICATIONS } from '../graphql/mutations';
export const NotificationDisabledSwitch = () => {
    const { t } = useGlobalization();
    const dispatch = useDispatch();
    const { config: { applicationId, tenantId, userId, notificationDisabled }, } = useSelectNotificationHub();
    const [toggleNotifications, { error: toggleNotificationsError }] = useMutation(TOGGLE_NOTIFICATIONS);
    React.useEffect(() => {
        if (toggleNotificationsError) {
            const errorMessage = notificationDisabled
                ? t('Unable to disable notifications')
                : t('Unable to enable notifications');
            dispatch(error(errorMessage));
            dispatch(setNotificationDisabled(!notificationDisabled));
        }
    }, [toggleNotificationsError]);
    return (React.createElement(FieldSwitchStyles.SwitchContainer, null,
        React.createElement(SwitchLabel, null, t('Notification')),
        React.createElement(FormControlLabel, { control: React.createElement(FieldSwitchStyles.Switch, { "data-cy": "notification-disabled-switch", color: "primary", checked: !notificationDisabled, onChange: () => {
                    dispatch(setNotificationDisabled(!notificationDisabled));
                    toggleNotifications({
                        variables: {
                            params: {
                                applicationId,
                                tenantId,
                                userId,
                                notificationDisabled: !notificationDisabled,
                            },
                        },
                    });
                } }), label: !notificationDisabled ? t('On') : t('Off') })));
};
const SwitchLabel = styled.div `
	margin: 0;
	color: #768d95;
	font-size: 0.875rem;
	line-height: 1.25rem;
	font-weight: 400;
	margin-left: ${rem(10)};
`;
